export const TableConstants = {
  itemsPerPageDefault: 30,
  itemsPerPageValues: [15, 30, 50, 100],
}
